import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormLabel,
  Grid,
  GridItem,
  HStack,
  Input,
  Radio,
  RadioGroup,
  SimpleGrid,
  Text,
  useMediaQuery,
  useToast,
  VStack,
} from "@chakra-ui/react";
import axios from "axios";
import jwtDecode from "jwt-decode";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ListCart from "../components/card/ListCart";
import AlertRole from "../components/modals/AlertRole";
import DeleteAllCart from "../components/modals/DeleteAllCart";
import PaymentMethod from "../components/modals/PaymentMethod";
import FetchData from "../services/FetchData";

//image
import QRIS from "../assets/payment/qris.png";
import BPD from "../assets/logo/bank-bpd.png";

export default function Cart() {
  const baseURL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const toast = useToast();
  const [mobile] = useMediaQuery("(max-width: 600px)");

  const [checkedItems, setCheckedItems] = useState({});
  const [listTrue, setListTrue] = useState([]);
  // const [quantity, setQuantity] = useState({});

  const [payment, setPayment] = useState("QRIS");
  const [email, setEmail] = useState("");
  const [hargaTotal, setHargaTotal] = useState(0);
  const [tax, setTax] = useState(0);
  const [countBarang, setCountBarang] = useState(0);
  const [reload, setReload] = useState(0);
  const [multiProduct, setMultiProduct] = useState(-1);

  const [loading, setLoading] = useState(false);
  const [modalPayment, setModalPayment] = useState(false);
  const [alertNoMultiProduct, setAlertNoMultiProduct] = useState(false);
  const [checkAll, setCheckAll] = useState(false);
  const [alertDeleteAll, setAlertDeleteAll] = useState(false);

  const UID = jwtDecode(localStorage.getItem("access_token"))?.data.id;
  const { data } = FetchData({ url: "/carts", reload: reload });
  const { data: data1 } = FetchData({
    url: "/users/" + UID,
  });

  var IDRConvert = Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
  });

  // console.log(multiProduct);

  useEffect(() => {
    if (data === null) return;
    setMultiProduct(
      localStorage.getItem("multi_product") === "0" ? false : true
    );
    const checkedItem = checkedItems;
    setEmail(data1?.email);
    data?.carts.forEach(function (cart) {
      checkedItem[cart.cart_id] = false;
    });
    setCheckedItems(checkedItem);
  }, [data]);

  useEffect(() => {
    if (data === null) return;
    let count = 0;
    let total = 0;
    let tax = 0;
    let index = [];
    if (checkAll) {
      data?.carts.forEach((e) => {
        count = count + 1;
        total = total + e.price;
        tax = tax + e.tax;
        index.push(e.cart_id);
        console.log(index);
      });
      console.log(index);
      setHargaTotal(total);
      setTax(tax);
      setCountBarang(count);
      setListTrue(index);
      return;
    }
    Object.keys(checkedItems).forEach((key) => {
      if (checkedItems[key] === true) {
        count = count + 1;
        index.push(parseInt(key));
        if (multiProduct && count === 1) {
          setHargaTotal(total);
          setCountBarang(count);
          setTax(tax);
          setListTrue(index);
          return;
        }
      }
    });
    setListTrue(index);
    const dataPrice = data?.carts.filter((item) =>
      index.includes(item.cart_id)
    );
    dataPrice?.forEach((item) => {
      total = total + item.price;
      tax = tax + item.tax;
    });
    setHargaTotal(total);
    setTax(tax);
    setCountBarang(count);
  }, [checkedItems]);

  async function deleteID(id) {
    await axios
      .delete(baseURL + "/carts/" + id, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
      })
      .then((res) => {
        console.log(res);
      })
      .catch((e) => console.log(e));
  }

  const handleAlertClose = () => {
    setAlertNoMultiProduct(false);
  };
  const handleModalPayClose = () => {
    setModalPayment(false);
  };
  const handlePay = async () => {
    if (email !== "") {
      if (!multiProduct && countBarang > 1) {
        setAlertNoMultiProduct(true);
      } else {
        setLoading(true);
        await axios
          .post(
            baseURL + "/orders/checkout",
            {
              items: listTrue,
              email: email,
              payment_type: payment,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.getItem("access_token"),
              },
            }
          )
          .then((res) => {
            console.log(res.data.data.payment_metadata);
            if (res.status === 200) {
              navigate(payment === "QRIS" ? "/scan-qris" : "/bpd-va", {
                state: res.data.data,
              });
            }
          })
          .catch((error) => {
            console.log(error);
            if (error.response.status === 400) {
              toast({
                title: "Payment Disabled",
                description:
                  "Maaf pembayaran dengan metode ini sedang dinonaktifkan, mohon gunakan pembayaran yang lain",
                status: "warning",
                duration: 5000,
                isClosable: true,
              });
            }
            if (error.response.status === 403) {
              toast({
                title: "Payment Over Limit",
                description:
                  "Maaf pembelian melebihi limit dengan QRIS, mohon gunakan VA untuk melanjutkan",
                status: "warning",
                duration: 5000,
                isClosable: true,
              });
            }
          });
        setLoading(false);
      }
    } else {
      toast({
        title: "Email Required",
        description: "Mohon inputkan email terlebih dahulu",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  };

  const handleReload = () => {
    window.location.reload();
  };
  const handleCheckAll = (e) => {
    const newCheckAll = !checkAll;
    setCheckAll(newCheckAll);
    if (newCheckAll) {
      const checkedItem = { ...checkedItems };
      Object.keys(checkedItem).forEach((key) => {
        checkedItem[key] = true;
      });
      setCheckedItems(checkedItem);
      return;
    }
    const checkedItem = { ...checkedItems };
    Object.keys(checkedItem).forEach((key) => {
      checkedItem[key] = false;
    });
    setCheckedItems(checkedItem);
    return;
  };

  const handleCheck = (e, cartId) => {
    const checkedItem = { ...checkedItems };
    setCheckedItems(null);
    checkedItem[cartId] = !checkedItem[cartId];
    setCheckedItems(checkedItem);
    if (checkAll) {
      let result = true;
      Object.keys(checkedItem).forEach((e) => {
        if (checkedItem[e] === false) {
          result = false;
        }
      });
      setCheckAll(result);
      return;
    }
    const check = Object.keys(checkedItem).every((e) => {
      return checkedItem[e] === true;
    });
    setCheckAll(check);
  };
  const handleDeleteAll = () => {
    let lastKey = Object.keys(checkedItems).length;
    console.log(lastKey);
    Object.keys(checkedItems).forEach((e, index) => {
      deleteID(e);
    });
    handleCloseDeleteAll();
    setReload(reload + 1);
  };
  const handleCloseDeleteAll = () => {
    setAlertDeleteAll(false);
  };
  const handleOpenDeleteAll = () => {
    setAlertDeleteAll(true);
  };

  return (
    <Grid templateColumns={mobile ? "repeat(1, 1fr)" : "repeat(3, 1fr)"}>
      <GridItem colSpan={2} px={mobile ? "2" : "40"} py={mobile ? "2" : "20"}>
        <Box hidden={!mobile} h="16"></Box>
        <Text hidden={mobile} fontWeight="500" fontSize="20">
          Keranjang Belanja
        </Text>
        <Box display="flex" py="2">
          <Checkbox
            size="lg"
            width="full"
            onChange={handleCheckAll}
            isChecked={checkAll}
          >
            Pilih Semua
          </Checkbox>
          <Button variant="ghost" onClick={handleOpenDeleteAll}>
            Hapus Semua
          </Button>
        </Box>
        <hr style={{ border: "1px solid #B9B9B9" }} />
        {data?.carts.map((item, key) => (
          <ListCart
            id={item.cart_id}
            checkedItem={checkedItems[item.cart_id]}
            handleChecked={handleCheck}
            img={item.img}
            name={item.name}
            price={item.price}
            quantity={item.qty}
            sellerId={data?.seller_id}
            itemId={item.item_id}
            handleReload={handleReload}
          />
        ))}
        {data?.carts.length === 0 && (
          <Text textAlign="center" fontWeight="600" pt="10">
            Maaf keranjang anda kosong
          </Text>
        )}
      </GridItem>
      <GridItem hidden={mobile}>
        <Box
          display="flex"
          justifyContent="center"
          minHeight="80vh"
          my="10"
          mr="20"
          flexDir="column"
        >
          <Box borderRadius="10px" border="2px solid #B9B9B9" p="10">
            <Text fontWeight="600" fontSize="20" py="3">
              Detail Pembayaran
            </Text>
            <FormControl>
              <FormLabel fontWeight="500">Email</FormLabel>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </FormControl>
            <Text fontWeight="600" fontSize="16" py="3">
              Metode pembayaran
            </Text>
            <RadioGroup
              defaultValue={payment}
              onChange={(value) => setPayment(value)}
            >
              <HStack>
                <Radio
                  size="lg"
                  name="1"
                  colorScheme="blue"
                  px="2"
                  value="QRIS"
                >
                  <img src={QRIS} alt="qris" width="100px" />
                </Radio>
                <Box display="flex" alignItems="center">
                  <Radio
                    px="2"
                    size="lg"
                    name="1"
                    colorScheme="blue"
                    value="VA"
                  />
                  <img src={BPD} alt="qris" width="70px" />
                  <Text pl="4" fontSize="20px">
                    Virtual Account
                  </Text>
                </Box>
              </HStack>
            </RadioGroup>
            <Text fontWeight="600" fontSize="16" py="3">
              Ringkasan belanja
            </Text>
            <SimpleGrid columns={2} alignContent="center">
              <Text fontSize="16" color="#4E4E4E">
                Harga ({countBarang} Barang)
              </Text>
              <Text
                display="flex"
                justifyContent="flex-end"
                fontWeight="700"
                fontSize="20"
              >
                {IDRConvert.format(hargaTotal)}
              </Text>
              {/* <Text fontSize="16" color="#4E4E4E">
                Pajak
              </Text>
              <Text
                display="flex"
                justifyContent="flex-end"
                fontWeight="700"
                fontSize="20"
              >
                {IDRConvert.format(tax)}
              </Text> */}
              <Text fontSize="16" color="#4E4E4E">
                Total Harga
              </Text>
              <Text
                display="flex"
                justifyContent="flex-end"
                fontWeight="700"
                fontSize="20"
              >
                {IDRConvert.format(hargaTotal)}
              </Text>
            </SimpleGrid>
            <Button
              mt="5"
              py="5"
              variant="outline"
              colorScheme="blue"
              w="full"
              disabled={listTrue.length === 0}
              onClick={handlePay}
              isLoading={loading}
            >
              Bayar
            </Button>
          </Box>
        </Box>
      </GridItem>
      <AlertRole isOpen={alertNoMultiProduct} onClose={handleAlertClose} />
      <DeleteAllCart
        handleDelete={handleDeleteAll}
        isOpen={alertDeleteAll}
        onClose={handleCloseDeleteAll}
      />
      <Box hidden={!mobile} h="16">
        <PaymentMethod
          countBarang={countBarang}
          email={email}
          handlePay={handlePay}
          hargaTotal={hargaTotal}
          listTrue={listTrue}
          payment={payment}
          setEmail={setEmail}
          setPayment={setPayment}
          tax={tax}
          open={modalPayment}
          onClose={handleModalPayClose}
          loading={loading}
        />
      </Box>
      <Box
        hidden={!mobile}
        w="full"
        h="16"
        bgColor="white"
        pos="fixed"
        bottom={0}
      >
        <hr />
        <SimpleGrid columns={2} p="2">
          <Box>
            <Text fontWeight="500" size="14">
              Total Harga
            </Text>
            <Text fontWeight="700" size="16">
              {IDRConvert.format(hargaTotal + tax)}
            </Text>
          </Box>
          <Box justifySelf="end">
            <Button
              disabled={listTrue.length < 1}
              onClick={() => setModalPayment(true)}
              colorScheme="blue"
              variant="outline"
              px="8"
            >
              Beli
            </Button>
          </Box>
        </SimpleGrid>
      </Box>
    </Grid>
  );
}
